import { useContext, useLayoutEffect, useState } from 'react';
import { media } from '../../../dataSets/media';
import { DashboardContext } from '../../../contextApi/DashboardContext';
import { AppContext } from '../../../contextApi/ContextApi';

export default function AdvItem({website, item}) {
    const {fetchImage, primary_color, accent_color, setToastMessage, messagesOptions} = useContext(AppContext);
    const { handleDeleteItem } = useContext(DashboardContext);
    const [imgURL, setImgURL] = useState(website?.settings?.logo);
    const [isHover, setIsHover] = useState(false);
    useLayoutEffect(()=>{
        fetchImage(website, item, setImgURL);
    },[])
  return (
    <div className='advForm_item'>
        <div className='advForm_item_img' style={{backgroundImage: `url(${imgURL ? imgURL : media.webingoLogo})`}} onMouseEnter={()=>{setIsHover(true)}} onMouseLeave={()=>{setIsHover(false)}}>
            <div className='advForm_item_xBtn' style={{backgroundColor:accent_color, color:primary_color}} onClick={()=>{handleDeleteItem(website.id, "settings.advertisments", item, setToastMessage, messagesOptions)}}>X</div>
        </div>
    </div>
  )
}
